<div class="scroll-container p-1" ref="manage_workflow">
    <div class="border-0 rounded-lg mt-1 ms-2">
        <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
                <ul class="nav nav-tabs" data-tabs="tabs">
                    <li
                    class="border rounded-lg me-2 nav-item"
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="[ active_tab === tab ? 'active' : 'inactive']"
                    @click="set_active_tab(tab)"
                    >
                    <a
                        class="text-decoration-none text-xs p-2"
                        :class="active_tab === tab ? 'text-white' : 'text-dark'"
                        href="#profile"
                        data-toggle="tab"
                    >
                        {{ tab }}
                    </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <hr class="ms-2"/>

    <div class="card-body mt-2">

        <!-- Unresolved -->
        <div v-if="active_tab === 'Unresolved'">
            <p v-if="unresolved_requests.length === 0" class="fw-bold text-xs">No unresolved requests yet</p>

            <div
                class="d-flex align-items-center gap-3 p-3 mb-3 rounded-3 border-start border-5 border-primary glassy-bg shadow"
                role="button" v-for="(unresolved, index) in unresolved_requests"
                :key="index"@click="selected_unresolved_request(unresolved.id)">
                <div class="rounded-circle custom-header bg-opacity-25 d-flex align-items-center justify-content-center flex-shrink-0 p-2">
                    <i class="fa-regular fa-envelope text-white fs-6"></i>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                    <div class="fw-semibold text-xs text-truncate">{{ unresolved.sender }}</div>
                    <div class="text-muted text-truncate small">{{ unresolved.message }}</div>
                </div>
                <small class="text-muted text-xs flex-shrink-0">{{ unresolved.date }}</small>
            </div>
        </div>

        <!-- Resolved -->
        <div v-else>
            <p v-if="resolved_requests.length === 0" class="fw-bold text-xs">No resolved requests yet</p>

            <div
                class="d-flex align-items-center gap-3 p-3 mb-3 rounded-3 border-start border-5 border-success glassy-bg shadow-sm"
                role="button" v-for="(resolved, index) in resolved_requests"
                :key="index" @click="view_resolved_request(resolved.id)">
                <div class="rounded-circle bg-success bg-opacity-25 d-flex align-items-center justify-content-center flex-shrink-0 p-2">
                    <i class="fa-regular fa-square-check text-white fs-6"></i>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                    <div class="fw-semibold text-xs text-truncate">{{ resolved.sender }}</div>
                    <div class="text-muted text-truncate small">{{ resolved.message }}</div>
                </div>
                <small class="text-muted text-xs flex-shrink-0">{{ resolved.date }}</small>
            </div>
        </div>
    </div>
</div>